import { render } from "./Authenticating.vue?vue&type=template&id=2f64abbc&scoped=true"
const script = {}

import "./Authenticating.vue?vue&type=style&index=0&id=2f64abbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f64abbc"]])

export default __exports__